import { ErrorMessage, Field } from "formik";
import moment from "moment";
import React, { Component } from "react";
import { ControlLabel, FormControl, FormGroup } from "react-bootstrap";
import "./form-field.style.scss";
import classNames from "classnames";
export default class RenderFormField extends Component {
  render() {
    const { name, type, label, options, dependOn, height, isView } = this.props;
    switch (type) {
      case "input":
        return (
          <div className="RenderFormField-wrapper">
            <FormGroup>
              <ControlLabel
                className={classNames({ required: !this.props.isNotRequired })}
                htmlFor={name}
              >
                {label}
              </ControlLabel>
              <Field id={name} name={name} className="form-control" />
              <div style={{ height: 8 }}>
                <ErrorMessage
                  render={(msg) => <div className="error-message">{msg}</div>}
                  name={name}
                />
              </div>
            </FormGroup>
          </div>
        );
      case "radio":
        return (
          <div className="RenderFormField-wrapper">
            <label
              className={classNames({ required: !this.props.isNotRequired })}
              id={name}
            >
              {label}
            </label>
            <FormGroup
              role="group"
              aria-labelledby={name}
              className="radio-form-container"
            >
              {options.map((option) => (
                <label key={option.value}>
                  <Field type="radio" name={name} value={option.value} />
                  {option.label}
                </label>
              ))}
              <div style={{ height: 8 }}>
                <ErrorMessage
                  render={(msg) => <div className="error-message">{msg}</div>}
                  name={name}
                />
              </div>
            </FormGroup>
          </div>
        );
      case "dropdown":
        return (
          <div className="RenderFormField-wrapper">
            <Field
              id={name}
              name={name}
              render={(props) => {
                const { field, form } = props;

                if (!field.value && options.length) {
                  form.setFieldValue(name, options[0].value);
                }
                return (
                  <FormGroup controlId={name}>
                    <ControlLabel
                      className={classNames({
                        required: !this.props.isNotRequired,
                      })}
                    >
                      {label}
                    </ControlLabel>
                    <FormControl
                      componentClass="select"
                      placeholder="Select"
                      {...field}
                    >
                      {options.map((option) => (
                        <option value={option.value}>{option.label}</option>
                      ))}
                    </FormControl>
                    <div style={{ height: 8 }}>
                      <ErrorMessage
                        render={(msg) => (
                          <div className="error-message">{msg}</div>
                        )}
                        name={name}
                      />
                    </div>
                  </FormGroup>
                );
              }}
            />
          </div>
        );

      case "readonlyDropdown":
        return (
          <div className="RenderFormField-wrapper">
            <FormGroup>
              <ControlLabel
                className={classNames({ required: !this.props.isNotRequired })}
                htmlFor={name}
              >
                {label}
              </ControlLabel>
              <Field
                id={name}
                name={name}
                render={({ field, form }) => {
                  const dependValue =
                    options.find((op) => op.value === form.values[dependOn]) ||
                    {};
                  if (field.value !== dependValue.label) {
                    form.setFieldValue(name, dependValue.label);
                  }
                  return (
                    <input
                      style={{ cursor: "not-allowed", pointerEvents: "none" }}
                      className="form-control"
                      value={field.value}
                      onKeyDown={(e) => {
                        e.preventDefault();
                      }}
                    />
                  );
                }}
              />
              <div style={{ height: 8 }}>
                <ErrorMessage
                  render={(msg) => <div className="error-message">{msg}</div>}
                  name={name}
                />
              </div>
            </FormGroup>
          </div>
        );
      case "datePicker":
        return (
          <div className="RenderFormField-wrapper">
            <FormGroup>
              <ControlLabel
                className={classNames({ required: !this.props.isNotRequired })}
                htmlFor={name}
              >
                {label}
              </ControlLabel>
              <Field
                name={name}
                render={({ field, form }) => {
                  // HTML date input requires YYYY-MM-DD; app stores DD/MM/YYYY
                  const toInputValue = (val) => {
                    if (!val) return "";
                    // Already YYYY-MM-DD
                    if (/^\d{4}-\d{2}-\d{2}$/.test(val)) return val;
                    // Try DD/MM/YYYY
                    const m = moment(val, "DD/MM/YYYY", true);
                    return m.isValid() ? m.format("YYYY-MM-DD") : "";
                  };
                  const toAppValue = (isoDate) => {
                    if (!isoDate) return "";
                    const m = moment(isoDate, "YYYY-MM-DD", true);
                    return m.isValid() ? m.format("DD/MM/YYYY") : "";
                  };
                  return (
                    <input
                      id={name}
                      type="date"
                      className="form-control"
                      value={toInputValue(field.value)}
                      onChange={(e) =>
                        form.setFieldValue(name, toAppValue(e.target.value))
                      }
                      onBlur={field.onBlur}
                    />
                  );
                }}
              />
              <div style={{ height: 8 }}>
                <ErrorMessage
                  render={(msg) => <div className="error-message">{msg}</div>}
                  name={name}
                />
              </div>
            </FormGroup>
          </div>
        );
      case "input-number":
        return (
          <div className="RenderFormField-wrapper">
            <FormGroup>
              <ControlLabel
                className={classNames({ required: !this.props.isNotRequired })}
                htmlFor={name}
              >
                {label}
              </ControlLabel>
              <Field
                id={name}
                name={name}
                render={({ field, form }) => {
                  const raw =
                    field.value != null && field.value !== ""
                      ? String(field.value).replace(/,/g, "")
                      : "";
                  const display = raw
                    ? Number(raw).toLocaleString("en-US")
                    : "";
                  return (
                    <input
                      id={name}
                      className="form-control"
                      value={display}
                      onChange={(e) => {
                        const stripped = e.target.value.replace(/[^0-9]/g, "");
                        form.setFieldValue(name, stripped || "");
                      }}
                      onBlur={field.onBlur}
                    />
                  );
                }}
              />
              <div style={{ height: 8 }}>
                <ErrorMessage
                  render={(msg) => <div className="error-message">{msg}</div>}
                  name={name}
                />
              </div>
            </FormGroup>
          </div>
        );
      case "button":
        return isView ? (
          <div></div>
        ) : (
          <div className="RenderFormField-wrapper">
            <FormGroup>
              <div style={{ height: 30 }}></div>
              <button
                type="button"
                className="btn btn-primary"
                style={{
                  backgroundColor: "#FFE600",
                  borderColor: "#7F7E82",
                  borderRadius: "3px",
                  fontWeight: 600,
                  marginLeft: "auto",
                  float: "left",
                  height: "30px",
                  fontSize: "10px",
                }}
              >
                {label}
              </button>
              <div style={{ height: 8 }}></div>
            </FormGroup>
          </div>
        );
      case "space":
        return <div style={{ visibility: "hidden", height: height }}></div>;
      default:
        return null;
    }
  }
}



// WEBPACK FOOTER //
// src/pages/Pricing/NewPricing/components/RenderFormField.js